import { render, staticRenderFns } from "./TopLinks.vue?vue&type=template&id=61a6f55c"
import script from "./TopLinks.vue?vue&type=script&lang=ts"
export * from "./TopLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports